import { createActions, createReducer } from 'reduxsauce'

import DetalhesRecursoRecebidoService from '../../servicos/DetalhesRecursoRecebidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaPlanoTrabalhoRecursoRecebidoInicio: [],
    buscaPlanoTrabalhoRecursoRecebidoSucesso: ['planoTrabalhoRecursoRecebido'],
    buscaPlanoTrabalhoRecursoRecebidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaPlanoTrabalhoRecursoRecebido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaPlanoTrabalhoRecursoRecebidoInicio())
        let serv = new DetalhesRecursoRecebidoService()
        return serv
            .consultarPlanoTrabalho(filtro)
            .then(response => dispatch(Creators.buscaPlanoTrabalhoRecursoRecebidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaPlanoTrabalhoRecursoRecebidoErro(error)))
    }
}

const buscaPlanoTrabalhoRecursoRecebidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaPlanoTrabalhoRecursoRecebidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaPlanoTrabalhoRecursoRecebidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.planoTrabalhoRecursoRecebido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_PLANO_TRABALHO_RECURSO_RECEBIDO_INICIO]: buscaPlanoTrabalhoRecursoRecebidoInicio,
    [Types.BUSCA_PLANO_TRABALHO_RECURSO_RECEBIDO_ERRO]: buscaPlanoTrabalhoRecursoRecebidoErro,
    [Types.BUSCA_PLANO_TRABALHO_RECURSO_RECEBIDO_SUCESSO]: buscaPlanoTrabalhoRecursoRecebidoSucesso,
})
